import { computed, ComputedRef, watch, ref } from 'vue';
import { storeToRefs } from 'pinia';
import useMyCollectionsStore from './my-collections';
import useHasCollectionContents from './use-has-collection-contents';
import { ContentFilters } from './types';

// simple wrapper around the store to trigger initial loading from a single place
const useMyCollections = (context: string, limit: number, filters?: ComputedRef<ContentFilters>) => {
  const store = useMyCollectionsStore();
  const { collections: storeCollections, isLoading, hasMore } = storeToRefs(store);
  const { load, create, update, remove, reset, saveOrder } = store;
  watch(
    storeCollections,
    () => {
      // trigger initial load or when views have reset

      if (store.collections.length === 0 && !store.isLoading && store.hasMore) {
        store.load(limit, context);
      }
    },
    { immediate: true },
  );

  const collections = computed(() => {
    if (!filters) {
      return storeCollections.value;
    }
    return storeCollections.value.filter((collection) => useHasCollectionContents(ref(collection.id), filters).value);
  });

  return {
    collections,
    isLoading,
    hasMore,
    load,
    create,
    update,
    remove,
    reset,
    saveOrder,
  };
};

export default useMyCollections;
